import inView from 'in-view';

export default function (el) {
  if (el === null) return false;

  const heroForm = document.querySelector('.js-hero-form');
  const heroCta = document.querySelector('.js-hero-cta');

  const handleScroll = () => {
    if (window.scrollY === 0) {
      el.classList.remove('opacity-0', '-translate-y-2', 'hidden');
    } else {
      el.classList.add('opacity-0', '-translate-y-2', 'hidden');
    }
  };

  // Add scroll event listener
  window.addEventListener('scroll', handleScroll);

  if (heroForm) {
    inView('.js-hero-form')
      .on('enter', () => {
        el.classList.remove('opacity-0', '-translate-y-2', 'hidden');
      })
      .on('exit', () => {
        el.classList.add('opacity-0', '-translate-y-2', 'hidden');
      });
  } else {
    el.classList.add('hidden');
  }

  if (heroCta) {
    inView('.js-hero-cta')
      .on('enter', () => {
        el.classList.remove('opacity-0', '-translate-y-2', 'hidden');
      })
      .on('exit', () => {
        el.classList.add('opacity-0', '-translate-y-2', 'hidden');
      });
  } else {
    el.classList.add('hidden');
  }

  // Initial check for scroll position
  handleScroll();
}
